import { defineMessages } from 'react-intl'

export default defineMessages({
  sortOldNew: {
    id: 'patientDossier.sortOldNew',
    defaultMessage: 'OLD-NEW'
  },
  sortNewOld: {
    id: 'patientDossier.sortNewOld',
    defaultMessage: 'NEW-OLD'
  }
})
